<template>
  <div class="analyst-assistant">
    <div class="analyst-assistant__panel">
      <div class="analyst-assistant__header">
        <div class="analyst-assistant__icon-wrap">
          <i class="analyst-assistant__icon icon-medal-line t-iconfont"></i>
        </div>
        <div class="analyst-assistant__header-content">
          <div class="analyst-assistant__title">销售打单分析</div>
          <div class="analyst-assistant__desc">
            将基于业务对象的历史跟进数据和基本信息综合分析，输出深度分析报告
          </div>
        </div>
      </div>

      <div class="analyst-assistant__body">
        <div class="analyst-assistant__section">
          <div class="analyst-assistant__section-title">
            <span class="analyst-assistant__section-bar"></span>
            <span class="analyst-assistant__section-text">分析对象</span>
          </div>
          <el-checkbox-group
            v-model="checkList"
            class="analyst-assistant__checkbox-group"
            @change="handleChange"
          >
            <el-checkbox
              v-for="option in options"
              :key="option.value"
              class="analyst-assistant__checkbox"
              :disabled="option.disabled"
              :label="option.label"
              :value="option.value"
            >
              <template #default>
                <div>{{ option.label }}</div>
              </template>
            </el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="analyst-assistant__section">
          <div class="analyst-assistant__section-title analyst-assistant__section-title--rule">
            <span class="analyst-assistant__section-bar"></span>
            <span class="analyst-assistant__section-text">分析规则</span>
          </div>

          <template v-for="card in visibleRuleCards" :key="card.type">
            <div
              v-if="card.type !== visibleRuleCards[0]?.type"
              class="analyst-assistant__rule-divider"
            ></div>
            <div class="analyst-assistant__group-title">{{ card.groupTitle }}</div>
            <div class="analyst-assistant__rule-card">
              <div class="analyst-assistant__rule-content">
                <div class="analyst-assistant__rule-name">{{ card.title }}</div>
                <div class="analyst-assistant__rule-meta">
                  <div class="analyst-assistant__rule-meta-item">
                    <span class="analyst-assistant__rule-meta-label">适用范围</span>
                    <span class="analyst-assistant__rule-meta-value">{{ card.scopeText }}</span>
                  </div>
                  <span class="analyst-assistant__rule-meta-divider"></span>
                  <div class="analyst-assistant__rule-meta-item">
                    <span class="analyst-assistant__rule-meta-label">跟进记录范围</span>
                    <span class="analyst-assistant__rule-meta-value">
                      {{ card.recordRangeText }}
                    </span>
                  </div>
                </div>
              </div>
              <span class="analyst-assistant__rule-action" @click="handleOpenEditDialog(card.type)">
                编辑
              </span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <Dialog
      v-model:show="dialogVisibleVisible"
      :close-on-click-modal="false"
      :max-height="800"
      :max-width="1008"
      :min-height="600"
      :min-width="800"
      title="编辑分析规则"
    >
      <div class="analyst-assistant__dialog">
        <div class="analyst-assistant__dialog-title">
          <div class="analyst-assistant__dialog-title-main">
            <span class="analyst-assistant__dialog-title-bar"></span>
            <span class="analyst-assistant__dialog-title-text">分析规则 Prompt</span>
          </div>
          <div class="analyst-assistant__dialog-title-desc">
            该规则将基于表单基础信息和最近 100 条跟进数据进行综合分析。
          </div>
        </div>
        <el-input
          v-model="editData[0].content"
          maxlength="1000"
          placeholder="请输入分析规则"
          rows="18"
          show-word-limit
          type="textarea"
        />
      </div>
      <template #footer>
        <el-button class="dialog-btn" @click="handleCancel">取消</el-button>
        <el-button
          class="dialog-btn"
          color="#7a52f4"
          :disabled="disabled"
          :loading="loadingSave"
          @click="handleSave"
        >
          确定
        </el-button>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
// import Dialog from '@/components/ai-dialog/index.vue'
import Dialog from '@/components/layout/dialog-layout/index.vue'
import { getSalesConfig, updateAnalyzeObject, updateAnalyzeRule } from '@/api/ai-setting'
import { ElMessage } from 'element-plus'
import xbb from '@xbb/xbb-utils'

const options = ref([
  {
    label: '线索',
    value: 1,
    disabled: false
  },
  {
    label: '客户',
    value: 2,
    disabled: false
  },
  {
    label: '商机',
    value: 3,
    disabled: false
  }
])

const ruleCards = [
  {
    groupTitle: '线索',
    recordRangeText: '最近 100 条记录',
    scopeText: '全部线索',
    title: '线索转化分析',
    type: 1
  },
  {
    groupTitle: '客户',
    recordRangeText: '最近 100 条记录',
    scopeText: '全部客户',
    title: '客户打单分析',
    type: 2
  },
  {
    groupTitle: '商机',
    recordRangeText: '最近 100 条记录',
    scopeText: '全部商机',
    title: '商机打单分析',
    type: 3
  }
]

const checkList = ref([])
const dataId = ref(null)
const editType = ref(0)
const dialogVisibleVisible = ref(false)
const editData = ref([])
const loadingSave = ref(false)
const allData = ref({})
const disabled = computed(() => {
  return !editData.value[0].content
})
const visibleRuleCards = computed(() => {
  return ruleCards.filter((card) => checkList.value.includes(card.type))
})

const handleOpenEditDialog = (type) => {
  editType.value = type
  editData.value = xbb.deepClone(allData.value[type] || [])
  dialogVisibleVisible.value = true
}

const handleChange = () => {
  updateAnalyzeObject({
    analyzeObjects: checkList.value,
    id: dataId.value
  })
    .then(() => {
      ElMessage.success('更新成功')
    })
    .catch(() => {
      ElMessage.error('更新失败')
    })
}

const handleCancel = () => {
  editData.value = xbb.deepClone(allData.value[editType.value])
  dialogVisibleVisible.value = false
}

const handleSave = () => {
  if (disabled.value) {
    ElMessage.warning('请输入分析规则内容')
    return
  }
  if (editData.value[0].content.length > 1000) {
    ElMessage.warning('分析规则内容不能超过1000个字符')
    return
  }

  loadingSave.value = true
  updateAnalyzeRule({
    content: editData.value[0].content,
    type: editType.value,
    id: editData.value[0].id
  })
    .then(() => {
      ElMessage.success('更新成功')
      allData.value[editType.value] = xbb.deepClone(editData.value)
      dialogVisibleVisible.value = false
      getData()
    })
    .catch(() => {
      ElMessage.error('更新失败')
    })
    .finally(() => {
      loadingSave.value = false
    })
}

const getData = () => {
  getSalesConfig({}).then((res) => {
    checkList.value = res.result.analyzeObjects || []
    allData.value = res.result.analyzeRule
    dataId.value = res.result.id
  })
}

onMounted(() => {
  getData()
})
</script>

<style lang="scss" scoped>
// 文字/Text-4 强调正文标题
$text-strong: #323233;
// 文字/Text-3 次强调正文标题
$text-secondary: #646566;
// 文字/Text-2 次要信息
$text-placeholder: #969799;
// 拓展色/紫罗兰/Violets-6
$violet-6: #7a52f4;
// 链接/Link-6 常规
$link-primary: #248df5;
// 线条/Line-1 浅线条
$line-light: #f2f3f5;
// 线条/Line-2 一般线条
$line-normal: #e5e6eb;
// 填充/纯白
$fill-white: #ffffff;
// 辅助灰
$text-muted: #9e9e9e;

.analyst-assistant {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  padding: 16px 0;
  justify-content: center;
  overflow-y: auto;

  &__dialog {
    // textarea
    :deep(.el-textarea) {
      .el-textarea__inner {
        padding: 16px 4px 0 20px;
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  &__panel {
    width: 1120px;
    border: 1px solid $line-normal;
    border-radius: 12px;
    background-color: $fill-white;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    height: max-content;
  }

  &__header {
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid $line-normal;
  }

  &__icon-wrap {
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border-radius: 8px;
    background-color: $fill-white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__icon {
    font-size: 20px;
    line-height: 20px;
    color: $text-strong;
  }

  &__header-content {
    flex: 1;
    min-width: 0;
  }

  &__title {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: $text-strong;
  }

  &__desc {
    font-size: 14px;
    line-height: 20px;
    color: $text-placeholder;
  }

  &__body {
    padding: 16px;
  }

  &__section {
    & + & {
      margin-top: 24px;
    }
  }

  &__section-title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  &__section-title--rule {
    margin-bottom: 12px;
  }

  &__section-bar {
    width: 2px;
    height: 12px;
    margin-right: 8px;
    border-radius: 2px;
    background-color: $violet-6;
    flex-shrink: 0;
  }

  &__section-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $text-strong;
  }

  &__checkbox-group {
    margin-bottom: 0;
  }

  &__checkbox {
    margin-right: 24px;
  }

  &__rule-divider {
    margin: 12px 0;
    height: 1px;
    background-image: linear-gradient(to right, $line-light 50%, rgba(255, 255, 255, 0) 0%);
    background-position: top;
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }

  &__group-title {
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 20px;
    color: $text-muted;
  }

  &__rule-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border: 1px solid $line-light;
    border-radius: 12px;
    background-color: $fill-white;
  }

  &__rule-content {
    flex: 1;
    min-width: 0;
    margin-right: 24px;
  }

  &__rule-name {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $text-strong;
  }

  &__rule-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &__rule-meta-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
  }

  &__rule-meta-label {
    margin-right: 12px;
    color: $text-secondary;
  }

  &__rule-meta-value {
    color: $text-strong;
  }

  &__rule-meta-divider {
    width: 1px;
    height: 12px;
    margin: 0 16px;
    background-color: $line-normal;
    flex-shrink: 0;
  }

  &__rule-action {
    flex-shrink: 0;
    font-size: 12px;
    line-height: 16px;
    color: $link-primary;
    cursor: pointer;
  }

  &__dialog-title {
    margin-bottom: 16px;
  }

  &__dialog-title-main {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  &__dialog-title-bar {
    width: 4px;
    height: 16px;
    margin-right: 8px;
    border-radius: 4px;
    background-color: $violet-6;
    flex-shrink: 0;
  }

  &__dialog-title-text {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: $text-strong;
  }

  &__dialog-title-desc {
    padding-left: 12px;
    font-size: 14px;
    line-height: 20px;
    color: $text-placeholder;
  }

  :deep(.el-checkbox) {
    margin-right: 24px;
  }

  :deep(.el-checkbox:last-child) {
    margin-right: 0;
  }

  :deep(.is-checked) {
    .el-checkbox__inner {
      background-color: $violet-6;
      border-color: $violet-6;
    }
  }

  :deep(.el-checkbox__label) {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: unset !important;
  }
}
</style>
